import api from "../../api/index";

const supportEmail = `${process.env.VUE_APP_BASE_URI}/enterprise/support`;
const suggestion = `${process.env.VUE_APP_BASE_URI}/enterprise/suggestion`;

const getDefaultState = () => {
  return {
    // walletDetail: [],
  };
};

const state = getDefaultState();

const getters = {
  //   walletDetail: (state) => state.walletDetail,
};

const actions = {
  async submitSupportEmail({ commit }) {
    commit("submitSupportEmail_request");
    const res = await api.post(supportEmail);
    if (res.data.status === "success") {
      commit("submitSupportEmail_success", res.data.data);
    }
    return res;
  },
  async submitSuggestion({ commit }) {
    commit("submitSuggestion_request");
    const res = await api.post(suggestion);
    if (res.data.status === "success") {
      commit("submitSuggestion_success", res.data.data);
    }
    return res;
  },
};

const mutations = {
  submitSupportEmail_request: (state) => (state.status = "loading"),
  submitSupportEmail_success: (state, data) => {
    state.status = "success";
    state.walletDetail = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
